<ng-content select="[slot=start]" />
<div class="spacer"></div>
<ng-content />
<ng-content select="[slot=end]" />
